import ExternalBenefitSelectIcon from "@/assets/ExternalBenefitSelectIcon.svg";
import ExternalBusinessSupportIcon from "@/assets/ExternalBusinessSupportIcon.svg";
import ExternalTroubleSupportIcon from "@/assets/ExternalTroubleSupportIcon.svg";
import { ServiceButtonExternalDisplayCompanyID } from "@/components/molecules/ServiceButton";
import { ServiceType } from "@/generated/graphql_billing";

type ExternalServiceDef = {
  icon: React.ReactNode;
  lowerCase: string;
  upperCase: string;
  code: string;
  type: ServiceType;
  nameJaJp: string;
  info?: string | React.ReactNode;
  description: string;
  note?: string | React.ReactNode;
  link: string;
  annotation?: string;
};

export const externalServices: ExternalServiceDef[] = [
  {
    icon: (
      <img
        src={ExternalTroubleSupportIcon.src}
        alt="External Service Icon of Trouble Support"
      />
    ),
    lowerCase: "external-troublesupport",
    upperCase: "EXTERNAL-TROUBLESUPPORT",
    code: "EXTERNAL_TROUBLESUPPORT",
    type: ServiceType.Other,
    nameJaJp: "お困りごとサポートデスク",
    info: "0570-003565",
    description: "パソコンやMikatanoに関する電話相談",
    note: "※お問合せフォームご案内の場合もあり",
    link: "https://mikatano-service.lp.x.moneyforward.com/techsd",
  },
  {
    icon: (
      <img
        src={ExternalBusinessSupportIcon.src}
        alt="External Service Icon of Business Support"
      />
    ),
    lowerCase: "external-businesssupport",
    upperCase: "EXTERNAL-BUSINESSSUPPORT",
    code: "EXTERNAL_BUSINESSSUPPORT",
    type: ServiceType.Other,
    nameJaJp: "ビジネスサポートデスク",
    info: "050-1754-0542",
    description: "売上増加を図る施策や補助金のご相談",
    note: (
      <div>
        <div css={{ color: "red" }}>
          ※2025/2/28 サービス提供終了予定 詳細はこちら(外部サイト)をクリック
        </div>
      </div>
    ),
    link: "https://mikatano-collabo.lp.x.moneyforward.com/bizsd_useful",
  },
  {
    icon: (
      <img
        src={ExternalBenefitSelectIcon.src}
        alt="External Service Icon of Benefit Select"
      />
    ),
    lowerCase: "external-benefitselect",
    upperCase: "EXTERNAL-BENEFITSELECT",
    code: "EXTERNAL_BENEFITSELECT",
    type: ServiceType.Other,
    info: <ServiceButtonExternalDisplayCompanyID />,
    nameJaJp: "ベネフィットセレクト",
    description: "日常生活の出費を補助する福利厚生",
    note: (
      <div>
        <div css={{ color: "red" }}>
          ※2025/1/31 新規申込受付停止 2025/2/28 サービス提供終了予定
          詳細はこちらをクリック
        </div>
      </div>
    ),
    link: "https://mikatano-collabo.lp.x.moneyforward.com/benefit",
    annotation: `ベネフィットセレクトはプラン契約後、
    翌営業日を目処にご利用いただけます。`,
  },
] as const;

export const externalServiceByCode = (code: string) =>
  externalServices.find((service) => service.code === code);
